import { ProtectedJsonAPI } from './ProtectedJsonAPI'

export const MeterDataFiles = ProtectedJsonAPI.extend(
  'meter_data_files',
  {
    index:   endpoint => endpoint,
    create:  endpoint => endpoint.useFormData(true).method('post'),
    show:    endpoint => endpoint.path(({id}) => id),
  }
)